import { render } from "./DataSection.vue?vue&type=template&id=02bb7f7c&scoped=true"
import script from "./DataSection.vue?vue&type=script&lang=js"
export * from "./DataSection.vue?vue&type=script&lang=js"

import "./DataSection.vue?vue&type=style&index=0&id=02bb7f7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02bb7f7c"]])

export default __exports__